import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import {
        AlertDialogContent,
        type AlertDialogContentEmits,
        type AlertDialogContentProps,
        AlertDialogOverlay,
        AlertDialogPortal,
        useForwardPropsEmits,
    } from 'reka-ui';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlertDialogContent',
  props: {
    forceMount: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emits = __emit;

    const delegatedProps = reactiveOmit(props, 'class');

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialogPortal), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogOverlay), {
        "data-slot": "alert-dialog-overlay",
        class: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-modal-overlay/50 fixed inset-0 z-50 flex items-center justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogContent), _mergeProps({ "data-slot": "alert-dialog-content" }, _unref(forwarded), {
            class: 
                    _unref(cn)(
                        'bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed z-50 grid w-full max-w-[calc(100%-2rem)] rounded-lg shadow-lg duration-200 sm:max-w-lg',
                        props.class,
                    )
                
          }), {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})